import React, { Fragment } from "react";
import PropTypes from "prop-types";
import errorsType from "../types/errorsType";
import {
  SectionTitle,
  Field,
  Label,
  LabelText,
  Input,
  Select,
  Option,
  Required,
  Error,
  Location,
} from "../styles/edit-form-styles";

const JobDetails = (props) => {
  const {
    jobProfile,
    inputOnChange,
    sectorOptions,
    vacancyReasonOptions,
    errors,
  } = props;
  const { jobTitle, location, postcode, vacancyReason, sectorId, jobType } =
    jobProfile;

  return (
    <Fragment>
      <SectionTitle>Job Details</SectionTitle>
      <Field>
        <Label htmlFor="job-title">
          <LabelText>
            Job Title <Required>*</Required>
          </LabelText>
        </Label>
        <Input
          error={!!errors.title}
          type="text"
          name="jobTitle"
          id="job-title"
          value={jobTitle}
          onChange={inputOnChange}
        />
        {errors.title && <Error>{`Job title ${errors.title}.`}</Error>}
      </Field>
      <Location>
        <Field location>
          <Label htmlFor="location">
            <LabelText>
              Location <Required>*</Required>
            </LabelText>
          </Label>
          <Input
            error={!!errors.location}
            type="text"
            name="location"
            id="location"
            value={location}
            onChange={inputOnChange}
          />
          {errors.location && <Error>{`Location ${errors.location}.`}</Error>}
        </Field>
        <Field postCode>
          <Label htmlFor="postcode">
            <LabelText>
              Post Code<Required>*</Required>
            </LabelText>
          </Label>
          <Input
            error={!!errors.postcode}
            type="text"
            name="postcode"
            id="postcode"
            value={postcode}
            onChange={inputOnChange}
          />
        </Field>
      </Location>
      <Field>
        <Label htmlFor="job-sector">
          <LabelText>
            Sector <Required>*</Required>
          </LabelText>
        </Label>
        <Select
          error={!!errors.sector_id}
          onChange={inputOnChange}
          id="job-sector"
          name="sectorId"
          title="Please select a sector..."
          value={sectorId}
        >
          <Option value="">Please select a sector...</Option>
          {sectorOptions.map((sectorOption) => (
            <Option key={sectorOption.id} value={sectorOption.id}>
              {sectorOption.name}
            </Option>
          ))}
        </Select>
        {errors.sector_id && <Error>Please select a sector.</Error>}
      </Field>
      {jobType === "permanent" && (
        <Field>
          <Label htmlFor="job-vacancy-reason">
            <LabelText>
              Vacancy Reason <Required>*</Required>
            </LabelText>
          </Label>
          <Select
            error={!!errors.vacancy_reason}
            onChange={inputOnChange}
            name="vacancyReason"
            id="job-vacancy-reason"
            value={vacancyReason}
            title="Please select a vacancy reason..."
          >
            <Option value="">Please select a vacancy reason...</Option>
            {vacancyReasonOptions.map((vacancyReasonOption) => (
              <Option
                key={vacancyReasonOption.id}
                value={vacancyReasonOption.id}
              >
                {vacancyReasonOption.name}
              </Option>
            ))}
          </Select>
          {errors.vacancy_reason && (
            <Error>Please select a vacancy reason.</Error>
          )}
        </Field>
      )}
    </Fragment>
  );
};

JobDetails.propTypes = {
  inputOnChange: PropTypes.func.isRequired,
  jobProfile: PropTypes.shape({
    jobTitle: PropTypes.string,
    location: PropTypes.string,
    postcode: PropTypes.string,
    vacancyReason: PropTypes.number,
    sectorId: PropTypes.number,
    jobType: PropTypes.string,
  }).isRequired,
  sectorOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  vacancyReasonOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  errors: errorsType.isRequired,
};

export default JobDetails;
